/**
 * Reorders top-level footer link columns as atomic units.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

const COLUMN_SELECTOR =
  '.cs-container > .cs-ul-wrapper, ' + '.cs-container > ul.cs-nav, ' + '.cs-top > ul.cs-ul';

export const footerColumnAdapter = {
  kind: 'footer-column',
  label: 'Footer column',
  itemSelector: COLUMN_SELECTOR,
  parentSelector: '.cs-container, .cs-top',
  reorderSelector: COLUMN_SELECTOR,
  reorderSiblingSelector: COLUMN_SELECTOR,
  requiredAncestorSelector: 'footer, [id^="cs-footer"], [data-pb-shared="footer"]',
  reorderAxis: 'grid',
  historyLabel: 'Reorder footer column',
  toastText: 'Footer column reordered',
  vtPrefix: 'pb-footcol-',
  vtSelector: COLUMN_SELECTOR,
  moveFn: moveSiblingPreservingEids,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    if (!probe.closest('footer, [data-pb-shared="footer"]')) return null;
    return probe.closest('.cs-ul-wrapper, ul.cs-nav, .cs-top > ul.cs-ul');
  }
};
